import { IDocument } from 'types/documents.types';
import { TranslationsApi } from '@lib/api';
import { AxiosRequestConfig } from 'axios';

export function getDocuments(lang: string, config?: AxiosRequestConfig) {
  return TranslationsApi.request<IDocument[]>(`/${lang}/documents`, config);
}

export function getNews(config?: AxiosRequestConfig) {
  return TranslationsApi.request('/news/dashboard', config);
}

export function getNewsDetail(id: string | number, config?: AxiosRequestConfig) {
  return TranslationsApi.request(`/news/${id}`, config);
}
